import type { TraitListColDef } from '../../TraitList.model';

const descriptionColDef: TraitListColDef = {
  field: 'description',
  headerName: 'Description',
  initialWidth: 500,
};

export default descriptionColDef;
